// oidc-client is not maintained anymore and has been archived by the owner.
// The long term solution is to implement the PKCE flow manually or by suing AppAuth-JS.

import { inject } from 'vue';
import { UserManager, UserManagerSettings } from 'oidc-client-ts';

import {
  OIDC_CONFIG,
  UserManagerSymbol,
  type UserManagerContextType,
} from './config';

const guard = async (to) => {
  const isSecured = to.matched.some((r) => r.meta.auth);

  if (isSecured) {
    if (!(await userManager.getUser())) {
      await userManager.signinRedirect({
        state: { fromUrl: to.fullPath },
      });
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

function useOIDC(): UserManagerContextType {
  const context = inject(UserManagerSymbol);

  if (!context) {
    throw new Error();
  }

  return context;
}

const createUserManager = (options: UserManagerSettings): UserManager => {
  return new UserManager({ ...OIDC_CONFIG, ...options });
};

const userManager = createUserManager(OIDC_CONFIG);

userManager.events.addAccessTokenExpired(() => {
  userManager.signinSilent().catch(userManager.signoutRedirect);
});

userManager.events.addAccessTokenExpiring(() => {
  userManager.signinSilent();
});

userManager.events.removeSilentRenewError(() => {
  userManager.signoutRedirect();
});

userManager.events.addUserSignedOut(() => {
  userManager.signoutRedirect();
});

export * from 'oidc-client-ts';
export { userManager, createUserManager, useOIDC, guard };
